<template>
    <appHeader> </appHeader>
   <!-- banner section -->
    <section class="w3l-banner-background"  >
        <div class="container">
            <div class="row" style="margin:0 auto;min-height:100svh; align-items: center;justify-content: center;">
                <div class="mypet-container">
                    <div class="mypet mypet-left" :style="petObj.petPhone?{background: 'url(/static/images/' + petObj.petPhoto + ') center/cover no-repeat #fff'}:none">
                    </div>
                    <div class="mypet mypet-right">
                        <div class="mypet-right-items">
                            <div class="mypet-right-icon">
                                <img class="img" src="@/assets/images/catc.png" v-if="petObj.petType === 'cat'" />
                                <img class="img" src="@/assets/images/dogc.png" v-else/>
                            </div>
                            <div class="mypet-right-item">
                                <div class="mypet-right-item-title">PET NAME:</div> 
                                <div class="mypet-right-item-content" style="font-weight: bold;">{{ petObj.petName }}</div>
                            </div>
                        </div>
                        <div class="mypet-right-items">
                            <div class="mypet-right-icon">
                            </div>
                            <div class="mypet-right-item">
                                <div class="mypet-right-item-title">BIRTHDATE:</div> 
                                <div class="mypet-right-item-content">{{ petObj.petBirthDate?.slice(0, 10)}}</div>
                            </div>
                        </div>
                        <div class="mypet-right-items">
                            <div class="mypet-right-icon">
                            </div>
                            <div class="mypet-right-item">
                                <div class="mypet-right-item-title">TYPE:</div> 
                                <div class="mypet-right-item-content">{{petObj.petCategory}}</div>
                            </div>
                        </div>
                        <div class="mypet-right-items">
                            <div class="mypet-right-icon">
                            </div>
                            <div class="mypet-right-item">
                                <div class="mypet-right-item-title">BREED:</div> 
                                <div class="mypet-right-item-content" >{{petObj.petType}}</div>
                            </div>
                        </div>
                        <div class="mypet-right-items" v-if="petObj.petEmailState === 1">
                            <div class="mypet-right-icon">
                                <img class="img" src="@/assets/images/email.png"/>
                            </div>
                            <div class="mypet-right-item">
                                <div class="mypet-right-item-title">EMAIL:</div> 
                                <div class="mypet-right-item-content">{{petObj.petMail}}</div>
                            </div>
                        </div>
                        <div class="mypet-right-items"  v-if="petObj.petPhoneState === 1">
                            <div class="mypet-right-icon">
                                <img class="img" src="@/assets/images/phonec.png"/>
                            </div>
                            <div class="mypet-right-item">
                                <div class="mypet-right-item-title">TEL:</div> 
                                <div class="mypet-right-item-content">{{petObj.petPhone}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="my-blur-mask " />
    </section>
  </template>
  
  <script>
  import appHeader from '@/components/appHeader.vue';
  export default {
    name: 'appHome', 
    components: {
      appHeader
    }
  }
  </script>
  <script setup>
import { api } from "@/assets/js/requests.js";
import { onMounted, onUnmounted, ref } from 'vue';
import { useRoute } from 'vue-router';
const petObj = ref({});
    onMounted(() => {
        const petId = useRoute().query.petid;
        api.petTags.queryPet(petId).then(res => { 
            const codeData = res.data?.data;
            if(!codeData || codeData == null){
                alert("No Pet")
                location.href = '/'
                return;
            }
            petObj.value = codeData
            console.log("petId:", petId, petObj.value.petPhoneState, petObj.value.petPhoneState == 1);
        }).catch(error => {
            location.href = '/'
        });
       
    });
    

    onUnmounted(() => {
        // 清理定时器
    });


 </script>
  
<style lang="css" scoped>
  /* 可以添加样式 */
.w3l-banner-background {
  width: 100%;
  min-height: 100svh;
  background: url(../assets/images/petsbg.png) no-repeat center;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  -ms-background-size: cover;
  
  /* transition: background-image 1s ease-in-out; */
}

.my-blur-mask{
  /* position: relative; */
  margin-top:-500px;
  width: 100%;
  height: 500px;
  background: url("../assets/images/petsbgmask.png") no-repeat center;
  background-size: cover;
  background-position: center;
  box-sizing: border-box;
  z-index:1;
  
}

.mypet-container{
    display: flex;
    align-items: center;
    justify-content: center;
    height:300px;
    width:820px;
    gap:20px;
    z-index: 100;

}


.mypet{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 800px;
    height:100%;
    border-radius: 20px;
    background-color: #fff;

}

.mypet-left{ 
    flex: 0 0 360px;
    min-width: 0;
    background: url(../assets/images/g66.jpg) no-repeat center;
    background-size: cover;
    background-color: #fff;
}
.mypet-right{
  display: flex;
  flex:1;
  flex-direction: column;
  padding:30px;
  align-items: flex-start;    /* 单行内元素顶部对齐 */
  align-content: flex-start;   /* 所有多行整体贴顶部，不垂直居中 */
  
}

.mypet-right-icon {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width:50px;
    padding:5px;
}
.mypet-right-icon .img{
    max-width: 25px;
    height: 20px;
}

.mypet-right-items {
    display: flex;
    align-items: flex-start;
    flex:1;
    color: var(--secondary-color);
}

.mypet-right-item {
    display: flex;
    flex:1;
    align-items: flex-start;
}


.mypet-right-item-title {
    font-size: 15px;
    font-weight: bold;
    padding:5px;


}

.mypet-right-item-content {
    font-size: 15px;   
    padding:5px; 
}


@media (max-width: 895px){ 
    .container{
        height:100svh;
        flex:1;
    }
.mypet-container {
    flex-direction: column;
    height:600px;
    z-index:2;
}
.my-blur-mask{
    height:560px;
    margin-top:-560px;
}
  .mypet{
    width:340px;
    height:auto;
  }
  .mypet-left{
    flex:0 0 340px;
  }
  .mypet-right{
    width: 340px;
    height: 340px;
    padding:15px 15px;
    flex:1;
  }
  .mypet-right-icon{
    width:40px;
  }
  .mypet-right-icon .img{
    max-width: 20px;
    height: 15px;
}

.mypet-right-items{
    display: flex;
    align-items: center;
}

.mypet-right-item{
    display: flex;
    align-items: center;
}
  .mypet-right-item-title{
    font-size:10px;
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }
  .mypet-right-item-content{
    word-break: break-all;
    display: flex;
    align-items: center;
    justify-content: center;
    flex:1;
  }
  .text-item{
    font-size:12px;
  }
}

</style>